import AppDispatcher from '../dispatcher';
import Constant from '../constants.js/Constant';
import LogoutConstant from '../../../routers/MainFrame/constants/Constants';
import restClient from '../../../routers/MainFrame/action/APIClient';

var GetDomainDetailsAction = function () {

}


GetDomainDetailsAction.prototype = {

    get: function (domainName) {
        restClient.getDomainDetails(domainName, function (error, response) {
            if (error) {
                if (error.status === 401) {
                    AppDispatcher.dispatch({
                        actionType: Constant.GET_DOMAIN_DETAILS,
                        data: error
                    });
                }
                else {
                    AppDispatcher.dispatch({
                        actionType: Constant.GET_DOMAIN_DETAILS,
                        data: error
                    });
                }
            } else if(response != null) {
                response['status'] = 200;
                AppDispatcher.dispatch({
                    actionType: Constant.GET_DOMAIN_DETAILS,
                    data: response
                });
            }
        })
    }
}

export default new GetDomainDetailsAction();